<template>
  <div
    class="cash-item"
    @click="$emit('click')"
    :class="{ disabled: data.status === 3 || data.status === 4 }"
  >
    <div class="top">
      <h1 v-if="data.status !== 5">¥{{ data.refund_amount }}</h1>
      <h1 v-else>{{ data.course_reward }}</h1>
      <div class="flex">
        <h2>
          <span v-if="types">{{ types[data.type] }}</span>
        </h2>
        <div class="user" v-if="data.invited_name && data.type !== 5 && data.type !== 8">
          <div v-if="data.invited_gravatar" class="img" :style="$bgd(data.invited_gravatar)" />
          <span class="grey">{{ data.invited_name }}</span>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="right">
        <div v-if="data.status === 0" class="primary">
          <i class="anyteachicon anyteach-wait" />
          <span>{{ fromNow(data.start_time) }}后自动到账</span>
        </div>
        <div v-if="data.status === 1" class="primary">
          <i class="anyteachicon anyteach-waiting" />
          <span>{{ fromNow(data.end_time) }}内可提现</span>
        </div>
        <div v-if="data.status === 2">
          <span class="grey">
            <i class="anyteachicon anyteach-success" />
            <span>已到账</span>
          </span>
          <span class="grey time">{{ refundTime }}</span>
        </div>
        <div v-if="data.status === 5" class="grey">
          <i class="anyteachicon anyteach-success" />
          <span>换课时</span>
        </div>
        <div v-if="data.status === 3" class="grey">
          <i class="anyteachicon anyteach-error2" />
          <span>已失效</span>
        </div>
        <div v-if="data.status === 4" class="grey">
          <i class="anyteachicon anyteach-error2" />
          <span>相关订单已退款</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { fromNow } from "./utils"
export default {
  name: "Item",
  props: ["data"],
  methods: {
    fromNow
  },
  computed: {
    types() {
      return this.$store.state.info.refund
    },
    refundTime() {
      const date = this.$moment(this.data.refund_time)
      const today = this.$moment()
      if (date.isBefore(today, "year")) {
        return date.format("YYYY-MM-DD HH:mm")
      } else {
        return date.format("MM-DD HH:mm")
      }
    },
  }
}
</script>
<style scoped lang="scss">
@import "./style.scss";

.user {
  font-size: 0.8rem;
}
.flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.cash-item {
  width: 100%;
  padding: 15px 0 0 0;
  margin: 0 auto 5px auto;
  border-radius: 4px;
  background: white;
  border: $border;
  box-shadow: $deep-shadow;
  transition: all 0.1s;
  &:active {
    background: $bgd-grey;
    transform: scale(0.98);
  }
  .success {
    color: $red;
  }
  .primary {
    color: $primary;
  }
  .grey {
    color: $black;
    opacity: 0.55;
  }

  .top {
    width: 100%;
    padding: 0 15px 5px 15px;
    h1 {
      font-size: 1.5rem;
      line-height: 1;
      margin: 0;
      @include avenir-demi();
    }
    h2 {
      @include avenir();
      font-size: 0.8rem;
      font-weight: 400;
      line-height: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
  .bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top: 1px solid #f5f5f5;
    padding: 5px 15px;
    * {
      font-size: 0.8rem;
    }
  }
  .right {
    i {
      margin: 0 3px 0 0;
    }
    .time {
      margin: 0 0 0 5px;
    }
  }
}

.disabled {
  opacity: 1;
  .top {
    opacity: 0.5;
    .grey {
      opacity: 1;
    }
  }
}
</style>
